import React from "react";

import { useSearchParams } from "routes/hooks";
import { MenuItem, Tab } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";

import { MySharedResources, ResourcesSharedWithMe } from "./components";

function SharedResources() {
  const sharedResourcesFlag = useFeatures("shared-resources");
  const [searchParams, setSearchParams] = useSearchParams();

  const panes = [
    {
      menuItem: (
        <MenuItem key="resources-shared-with-me">
          {sharedResourcesFlag?.settings?.sharedWithMeTab?.name ||
            "Resources Shared With Me"}
        </MenuItem>
      ),
      render: () => {
        return <ResourcesSharedWithMe />;
      },
    },
  ];

  if (sharedResourcesFlag?.canShare) {
    panes.unshift({
      menuItem: (
        <MenuItem key="my-shared-resources">
          {sharedResourcesFlag?.settings?.myShareTab?.name ||
            "My Shared Resources"}
        </MenuItem>
      ),
      render: () => {
        return <MySharedResources />;
      },
    });
  }

  const tabsMap = sharedResourcesFlag?.canShare
    ? {
        mySharedResources: 0,
        sharedWithMe: 1,
      }
    : {
        sharedWithMe: 0,
      };

  return (
    <Tab
      menu={{ secondary: true, pointing: true }}
      panes={panes}
      activeIndex={
        tabsMap[searchParams?.tab] ||
        (sharedResourcesFlag?.canShare
          ? tabsMap.mySharedResources
          : tabsMap.sharedWithMe)
      }
      onTabChange={(e, { activeIndex }) => {
        setSearchParams({ tab: Object.keys(tabsMap)[activeIndex] });
      }}
    />
  );
}

export default SharedResources;
